import { useMemo } from 'react';
import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { useBrokerageDivisions } from '@services/brokerage-division';

export interface BrokerageDivisionTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

export const BrokerageDivisionTypeaheadFilter = (componentProps: BrokerageDivisionTypeaheadFilterProps) => {
  const { value, disabled } = componentProps;

  const { brokerageDivisions } = useBrokerageDivisions({
    enabled: true,
  });

  const items = useMemo(() => {
    return brokerageDivisions.map((division) => ({
      key: division.id,
      label: division.label,
      subLabel: division.type ?? undefined,
      value: division.id,
    }));
  }, [brokerageDivisions]);

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={items ?? []}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={componentProps?.fieldConfig?.selectField?.limitTags ?? 1}
      onChange={componentProps.onChange}
      horizontalLabel={true}
    />
  );
};
